import { menueRouterMap } from '@/router'

const menu = {
  state: {
    menus: [],
    opened: true,
    created: false
  },
  mutations: {
    SET_MENUS: (state, routers) => {
      state.menus = routers
    },
    TOGGLE_SIDEBAR: state => {
      state.opened = !state.opened
    },
    MENU_CREATED: state => {
      state.created = true
    }
  },
  actions: {
    GenerateMenus ({ commit }, permission) {
      return new Promise(resolve => {
        let pjson = {}
        for (let i = 0; i < permission.length; i++) {
          pjson[permission[i].action] = permission[i].value
        }
        let menuAdd = []
        for (let i = 0; i < menueRouterMap.length; i++) {
          let m = menueRouterMap[i]
          if (m.permission === 'setting') {
            menuAdd.push(m)
          }
          if (pjson[m.permission]) {
            menuAdd.push(m)
          }
        }
        commit('SET_MENUS', menuAdd)
        resolve()
      })
    },
    ToggleSideBar ({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    MenuCreated ({commit}) {
      commit('MENU_CREATED')
    }
  }
}

export default menu



// WEBPACK FOOTER //
// ./src/store/modules/menu.js